import { LinearProgress } from "@mui/material";

export const LoadingBar = () => <LinearProgress sx={{ m: "2rem" }} />;
